// What "Still owed" on the refunds list is made of (RefundsPanel): no page imports, so it is tested alone.
import { money } from './collectionsShared';

/** What "Still owed" is made of: Ejar's balance + ours not on Ejar yet (Salik, Darb, parking, fines). */
export const owedParts = (r) => {
    const u = r.unregistered || {};
    const trips = (k, label) => (u[k] && u[k].amount > 0.05
        ? { label, amount: u[k].amount, note: `${u[k].n} ${k === 'parking' ? 'time(s)' : 'trip(s)'}${u[k].coveredOnEjar ? ` · Ejar covers ${money(u[k].coveredOnEjar)} of ${money(u[k].portalTotal)}` : ''}` }
        : null);
    return [
        (r.ejar?.remaining || 0) > 0.05 ? { label: 'Balance on the Ejar contract', amount: r.ejar.remaining, note: 'charges not paid on Ejar' } : null,
        trips('toll', 'Salik not on Ejar'),
        trips('darb', 'Darb not on Ejar'),
        trips('parking', 'Parking not on Ejar'),
        u.fines && u.fines.amount > 0.05 ? { label: 'Fines not on Ejar', amount: u.fines.amount, note: `${u.fines.n} fine(s)` } : null,
    ].filter(Boolean);
};
